import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const blocks = [{
  title: 'Website Support',
  price: '£150',
  cadence: '/mo + VAT',
  term: '12-month agreement',
  summary: "Ongoing website care so you don't have to worry about updates, security, or basic content edits.",
  items: ['Monthly platform and plugin updates', 'Security monitoring and regular backups', 'Content updates (up to 4 per month)', 'Performance and uptime monitoring', 'Priority email support', 'Simple monthly summary report']
}, {
  title: 'Website & Creative Support',
  price: '£550',
  cadence: '/mo + VAT',
  term: 'Ongoing monthly',
  summary: 'Flexible monthly design and brand support for when you want a creative partner on call, not just a one-off project.',
  items: ['Up to 10 hours of design time per month', 'Social media graphics and templates', 'Marketing collateral (flyers, PDFs, ads)', 'Website tweaks and small updates', 'Brand consistency reviews', 'Priority turnaround on requests'],
  note: 'Unused hours do not roll over.'
}];
export function OptionalSupport() {
  return <section id="support" className="py-20 md:py-32 px-5 md:px-10 bg-paper border-b border-rule/60" data-id="element-150">
      <div className="max-w-6xl mx-auto" data-id="element-151">
        <ScrollReveal data-id="element-152">
          <div className="mb-12 md:mb-16 max-w-3xl" data-id="element-153">
            <p className="text-[11px] uppercase tracking-[0.3em] text-red font-bold mb-6 flex items-center gap-3" data-id="element-154">
              <span className="w-8 h-px bg-red" data-id="element-155" />
              Optional Support
            </p>
            <h2 className="text-4xl md:text-6xl leading-[0.95] tracking-[-0.04em] text-ink font-light mb-6" data-id="element-156">
              Ongoing support,
              <br data-id="element-157" />
              <span className="font-bold italic" data-id="element-158">if you want it.</span>
            </h2>
            <p className="text-base md:text-lg text-ink-soft leading-relaxed font-light max-w-2xl" data-id="element-159">
              Optional add-ons — not required to move forward. Available
              alongside or after the core project, whenever you need a creative
              partner on call.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-160">
          {blocks.map((block, i) => <ScrollReveal key={block.title} delay={i * 0.1} data-id="element-161">
              <div className="group relative bg-ivory border border-rule p-7 md:p-9 rounded-sm h-full flex flex-col hover:border-ink/30 transition-colors duration-500" data-id="element-162">
                {/* Optional pill */}
                <div className="absolute top-5 right-5" data-id="element-163">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-ink-mute bg-paper border border-rule px-2.5 py-1 font-bold rounded-full" data-id="element-164">
                    Optional
                  </span>
                </div>

                <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-3 font-bold" data-id="element-165">
                  Add-on · 0{i + 1}
                </p>
                <h3 className="text-2xl md:text-3xl text-ink font-medium tracking-tight mb-5" data-id="element-166">
                  {block.title}
                </h3>

                <div className="flex items-baseline gap-1.5 mb-2" data-id="element-167">
                  <span className="text-4xl md:text-5xl text-ink font-light tracking-tight" data-id="element-168">
                    {block.price}
                  </span>
                  <span className="text-sm text-ink-mute font-medium" data-id="element-169">
                    {block.cadence}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-xs text-ink-mute mb-6 pb-6 border-b border-rule" data-id="element-170">
                  <ClockIcon className="w-3.5 h-3.5" data-id="element-171" />
                  <span className="uppercase tracking-[0.18em] font-bold" data-id="element-172">
                    {block.term}
                  </span>
                </div>

                <p className="text-sm md:text-base text-ink-soft leading-relaxed font-light mb-6" data-id="element-173">
                  {block.summary}
                </p>

                <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-4 font-bold" data-id="element-174">
                  What's included
                </p>
                <ul className="space-y-3 mb-4 flex-1" data-id="element-175">
                  {block.items.map(item => <li key={item} className="flex items-start gap-3 text-sm text-ink font-light leading-relaxed" data-id="element-176">
                      <CheckIcon className="w-3.5 h-3.5 text-red flex-shrink-0 mt-1" data-id="element-177" />
                      {item}
                    </li>)}
                </ul>

                {block.note && <p className="text-xs text-ink-mute italic font-light pt-4 border-t border-rule mt-auto" data-id="element-178">
                    {block.note}
                  </p>}
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal delay={0.3} data-id="element-179">
          <p className="text-center text-xs md:text-sm text-ink-mute italic font-light mt-10 max-w-xl mx-auto" data-id="element-180">
            These are completely optional and can be added at any point — during
            the project, at handover, or further down the line.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}